import { connect } from 'react-redux'
import * as urls from '../../../../constants/api';
import MenuSearch from '../../../../features/commons/Menu/SearchMenu'
import { setAmbients, setBaths, setAreaMin, setAreaMax, setPriceMin, setPriceMax, retriveFilters, retrivePropertyTypes,
        addPropertyType, addOperationType, changeCurrency, setAreaMinLow, setAreaMaxLow ,
        setCategory, setUbication, addSubPropertyType, setUnitState, setPlant, setTerrain, setAvenue, setFocus, resetFilters, saveOriginPath,
			 	saveSubPropertyType, resetSubDepartamentoType, resetSubPropertyType, retriveOperationTypes } from '../../../../actions/searchBar'
import { retriveCategories, retrivePlantsTypes } from '../../../../actions/office';
import { retriveAvenues, retriveFocus } from '../../../../actions/retails';
import { resetEntrepreneurshipId } from '../../../../actions/entrepreneurship';
import { retriveLandUses } from '../../../../actions/terrains';
import { residentialsTypes, retriveUbications, retriveUnitState } from '../../../../actions/residential';
import { setPhone } from '../../../../actions/header'

const mapStateToProps = (state, ownProps) => {
  return {
    originPath: state.searchBar.originPath,
    originOffice: state.searchBar.originOffice,
  	operation_types: state.propiedades.operation_types,
    operations: state.searchBar.operation_type, //chosen operation types
    property_types: state.propiedades.property_types, //list of property types
    property_types_loading: state.propiedades.property_types_loading,
		sub_departamento_type: state.searchBar.sub_departamento_type,
    property_type: state.searchBar.property_type, //the chosen one
		sub_property_type: state.searchBar.sub_property_type,
		all_property_types: state.searchBar.all_property_types,
    properties_selected: state.searchBar.property_types,
    zona: state.searchBar.zona,
    min_price: state.searchBar.price_min,
    max_price: state.searchBar.price_max,
    currency: state.searchBar.currency,
    min_area: state.searchBar.area_min,
    max_area: state.searchBar.area_max,
    min_area_low: state.searchBar.area_low_min,
    max_area_low: state.searchBar.area_low_max,
    ambients: state.searchBar.ambients,
    bathrooms: state.searchBar.bathrooms,
    garages: state.searchBar.garages,
    bedrooms: state.searchBar.bedrooms,
    naves: state.searchBar.naves,
    category: state.searchBar.category,
    ubication: state.searchBar.ubication,
    plant_type: state.searchBar.plant_type,
    terrain: state.searchBar.terrain,
    selected_avenue: state.searchBar.avenue,
    selected_focus: state.searchBar.focus,
    avenues: state.retails.avenues,
    focus: state.retails.focus,
    categories: state.office.categories,
    ubications: state.residential.ubications,
    unit_state: state.residential.unit_state,
    plants: state.office.plants,
    terrains: state.terrains.uses,
    residentialTypes: state.residential.property_types,
    is_professional_use: state.residential.is_professional_use,
    is_brand_new: state.residential.is_new,
    unit_states: state.residential.unit_state
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
		resetEntrepreneurshipId: () => dispatch(resetEntrepreneurshipId()),
		saveOriginPath: (value) => dispatch(saveOriginPath(value)),
		retrivePropertyTypes: (value) => dispatch(retrivePropertyTypes(value)),
    setPropertyTypes: () => dispatch(retrivePropertyTypes(urls.HOME)),
		saveSubPropertyType: (value) => dispatch(saveSubPropertyType(value)),
    onSelectAmbients: value => dispatch(setAmbients(value)),
    onSelectBaths: value => dispatch(setBaths(value)),
    onChangeAreaMin: event => dispatch(setAreaMin(event.target.value)),
    onChangeAreaMax: event => dispatch(setAreaMax(event.target.value)),
    onChangeAreaMinLow: event => dispatch(setAreaMinLow(event.target.value)),
    onChangeAreaMaxLow: event => dispatch(setAreaMaxLow(event.target.value)),
    onChangePriceMin: event => dispatch(setPriceMin(event.target.value)),
    onChangePriceMax: event => dispatch(setPriceMax(event.target.value)),
    addPropertyType: value => dispatch(addPropertyType(value)),
		addSubPropertyType: value => dispatch(addSubPropertyType(value)),
		retriveOperationTypes: value => dispatch(retriveOperationTypes(value)),
    addOperationType: value => dispatch(addOperationType(value)),
    changeCurrency: (value) => dispatch(changeCurrency(value)),
    onSelectCategory: (value) => dispatch(setCategory(value)),
    onSelectUbication: (value) => dispatch(setUbication(value)),
    onSelectUnitState: (value) => dispatch(setUnitState(value)),
    onSelectPlant: (value) => dispatch(setPlant(value)),
    onSelectTerrain: (value) => dispatch(setTerrain(value)),
    onSelectAvenue: (value) => dispatch(setAvenue(value)),
    onSelectFocus: (value) => dispatch(setFocus(value)),
		resetSubDepartamentoType: () => dispatch(resetSubDepartamentoType()),
		resetSubPropertyType: () => dispatch(resetSubPropertyType()),
    didMount: () => {
      dispatch(retriveFilters()),
      // dispatch(retriveAvenues()),
      dispatch(retriveFocus()),
      dispatch(retriveCategories())
      dispatch(retriveLandUses())
      dispatch(residentialsTypes())
      dispatch(retrivePlantsTypes())
      dispatch(retriveUbications())
      dispatch(retriveUnitState())
     },
     resetAllFilters: () => dispatch(resetFilters()),
     setPhone: (value) => dispatch(setPhone(value))
  }
}

const Menu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuSearch)

export default Menu



// WEBPACK FOOTER //
// ./src/containers/Sections/Menu/SearchMenu/index.js